module.exports = __webpack_public_path__ + "static/35-1a17155a7f1742e95d376f9dd14a1914.gif";